module.exports = __webpack_public_path__ + "img/customer-icon-23.80091c54.png";